// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SortLabel--moderator":"fn_a bhe_hq","SortLabel__newFeature":"fn_b bhe_vh bhe_vv"};